var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "scroll" }, on: { mousewheel: _vm.scrollout } },
    [
      _vm.isproblem
        ? _c("main", { staticClass: "site-content", attrs: { role: "main" } }, [
            _c("div", [
              _c("div", { staticClass: "slider-1" }, [
                _c("img", {
                  attrs: { src: "/static/img/banner-new.png", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "slider-text-carousel" },
                  [
                    _c(
                      "el-carousel",
                      {
                        attrs: {
                          interval: 5000,
                          arrow: "never",
                          height: "23vh"
                        }
                      },
                      [
                        _c("el-carousel-item", [
                          _c("p", [_vm._v("产业互联网综合服务平台")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("企业管理云系统")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("让生意不再难 令管理更简单")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-carousel-item",
                          [
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  gutter: 20,
                                  type: "flex",
                                  justify: "center"
                                }
                              },
                              [
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("年销售额")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("500万以下")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("免费使用")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("年销售额")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("5百-2千万")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("2400元/年")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("年销售额：2千万-1亿")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("贸易版：9000元/年")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("制造版：18000元/年")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c("p", [_vm._v("年销售额：1亿以上")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("贸易版：18000元/年")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("制造版：36000元/年")])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-carousel-item",
                          [
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  gutter: 20,
                                  type: "flex",
                                  justify: "center"
                                }
                              },
                              [
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("p", [_vm._v("高效精益的批流程")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("p", [_vm._v("智能计算交货周期")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 6 } }, [
                                  _c("p", [_vm._v("实时掌握客户商机")])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticStyle: { "margin-top": "20px" },
                                attrs: {
                                  gutter: 20,
                                  type: "flex",
                                  justify: "center"
                                }
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("p", [_vm._v("大数据过滤企业财务风险")])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("p", [_vm._v("云存储自动备份安全有保障")])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-carousel-item",
                          [
                            _c(
                              "el-row",
                              {
                                attrs: {
                                  gutter: 20,
                                  type: "flex",
                                  justify: "center"
                                }
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("p", [
                                    _vm._v("操作简单 学习容易 一点就会")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("p", [
                                    _vm._v("管理前置 任务驱动 老板好帮手")
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticStyle: { "margin-top": "20px" } }, [
                              _vm._v("连通企业微信、税所、发票等多种接口")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "product-box" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "product-bottom" }, [
                  _c(
                    "ul",
                    {
                      on: {
                        mouseenter: function($event) {
                          _vm.enter("tradecloud")
                        },
                        mouseleave: function($event) {
                          _vm.leave("tradecloud")
                        }
                      }
                    },
                    [
                      _c("li", [_vm._v("销售管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("采购管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("库存管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("应收管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("应付管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("财务管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("行政人事")]),
                      _vm._v(" "),
                      !_vm.tradebtn
                        ? _c("li", [_vm._v("......")])
                        : _c("li", [
                            _c(
                              "span",
                              {
                                staticClass: "reg",
                                on: {
                                  click: function($event) {
                                    _vm.register("trade")
                                  }
                                }
                              },
                              [_vm._v("立即注册")]
                            )
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      on: {
                        mouseenter: function($event) {
                          _vm.enter("makeclound")
                        },
                        mouseleave: function($event) {
                          _vm.leave("makeclound")
                        }
                      }
                    },
                    [
                      _c("li", [_vm._v("进销存管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("生产管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("MRP物料需求")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("应收应付")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("成本管理")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("财务会计")]),
                      _vm._v(" "),
                      _c("li", [_vm._v("行政人事")]),
                      _vm._v(" "),
                      !_vm.makebtn
                        ? _c("li", [_vm._v("......")])
                        : _c("li", [
                            _c(
                              "span",
                              {
                                staticClass: "reg",
                                on: {
                                  click: function($event) {
                                    _vm.register("make")
                                  }
                                }
                              },
                              [_vm._v("立即注册")]
                            )
                          ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(2)
          ])
        : _c("problem")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pro-title" }, [
      _c("p", [_vm._v("我们的产品")]),
      _vm._v(" "),
      _c("p", [_vm._v("Our products")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product-top" }, [
      _c("ul", [
        _c("li", [
          _c("div", { staticClass: "imgbox" }, [
            _c("img", { attrs: { src: "/static/img/maoyiyun1.png", alt: "" } })
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "name" }, [_vm._v("贸 易 云")])
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("div", { staticClass: "imgbox" }, [
            _c("img", {
              attrs: { src: "/static/img/zhizhaoyun1.png", alt: "" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "name" }, [_vm._v("制 造 云")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottomimg" }, [
      _c("img", { attrs: { src: "/static/img/Waves.png", alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-098e74d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098e74d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/home.vue
// module id = null
// module chunks = 